/**
 * Converts a hex color (e.g. #FF0000) into an rgba() string with optional alpha transparency.
 * @param {string} hex - A valid 3- or 6-digit hex color string.
 * @param {number} alpha - Alpha transparency (0 to 1). Default is 0.2.
 * @returns {string} - The corresponding rgba string or 'transparent' if invalid.
 */
const namedColors = {
  black: '#000000',
  white: '#ffffff',
  red: '#ff0000',
  green: '#008000',
  blue: '#0000ff',
  yellow: '#ffff00',
  cyan: '#00ffff',
  magenta: '#ff00ff',
  gray: '#808080',
  grey: '#808080',
  orange: '#ffa500',
  pink: '#ffc0cb',
  brown: '#a52a2a',
  purple: '#800080',
  lime: '#00ff00',
  navy: '#000080',
  olive: '#808000',
  teal: '#008080',
  maroon: '#800000',
  aqua: '#00ffff',
  fuchsia: '#ff00ff',
  silver: '#c0c0c0',
  gold: '#ffd700',
  tomato: '#ff6347',
};

/**
 * Converts a hex or named color to rgba with optional alpha.
 * @param {string} color - Hex (#RRGGBB or #RGB) or CSS color name.
 * @param {number} alpha - Alpha value from 0 to 1.
 * @returns {string} rgba() string or 'transparent' if invalid.
 */
export default function hexToRgba(color, alpha = 0.2) {
  if (!color) return 'transparent';

  // Convert named color to hex
  const lower = color.toLowerCase();
  if (namedColors[lower]) {
    color = namedColors[lower];
  }

  // Match hex format
  const hexMatch = /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
  if (!hexMatch) return 'transparent';

  let c = color.substring(1).split('');
  if (c.length === 3) {
    c = [c[0], c[0], c[1], c[1], c[2], c[2]];
  }

  const r = parseInt(c[0] + c[1], 16);
  const g = parseInt(c[2] + c[3], 16);
  const b = parseInt(c[4] + c[5], 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
